import { render, staticRenderFns } from "./OrderServiceDistribution.vue?vue&type=template&id=19bb5796&"
import script from "./OrderServiceDistribution.vue?vue&type=script&lang=js&"
export * from "./OrderServiceDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports